<template>
  <div>
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="iccid">
        <el-input v-model="queryParams.iccid" placeholder="ICCID"  @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item prop="orderNum">
        <el-input v-model="queryParams.orderNum" placeholder="商户单号"  @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item prop="operator">
        <el-input v-model="queryParams.operator" placeholder="申请人"  @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="dateRange"
          style="width: 240px"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-upload"  @click="batchUploadProduct">批量转套餐</el-button>
      </el-form-item>
    </el-form>
    <div style="margin-top: 10px">
      <el-table :data="tableData" border>
        <el-table-column prop="orderNum" label="商户单号" align="center"></el-table-column>
        <el-table-column prop="iccid" label="旧ICCID" align="center">
          <template slot-scope="scope">
            <div style="color: #4466AD;cursor: pointer;text-decoration: underline;" class="complaint-class" @click="jumpCardDetails(scope.row.iccid)">{{ scope.row.iccid }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="targetIccid" label="新ICCID" align="center">
          <template slot-scope="scope">
            <div style="color: #4466AD;cursor: pointer;text-decoration: underline;" class="complaint-class" @click="jumpCardDetails(scope.row.targetIccid)">{{ scope.row.targetIccid }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="productName" label="套餐名" align="center"></el-table-column>
        <el-table-column prop="operator" label="申请人" align="center"></el-table-column>
        <el-table-column prop="remark" label="说明" align="center"></el-table-column>
        <el-table-column prop="createTime" label="提交时间" align="center"></el-table-column>
      </el-table>
    </div>
    <div class="block" style="margin-top: 30px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <!-- 批量添加弹出框 -->
    <el-dialog title="转套餐批量添加" :visible.sync="batchFormOpen" width="680px" append-to-body :close-on-click-modal="false">
      <el-form ref="batchForm" :model="batchForm" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="字段类型" prop="fieldType">
              <el-radio v-model="batchForm.fieldType" label="1" >批量卡号</el-radio>
              <el-radio v-model="batchForm.fieldType" label="2" >EXCEL上传</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="batchForm.fieldType == '1'">
          <el-col :span="24">
            <el-form-item label="卡号列表" prop="iccids">
              <el-input v-model="batchForm.iccids" type="textarea" clearable placeholder="请输入内容" rows="8"></el-input>
              <div style="padding-top:10px">
                <p style="font-size: 13px;line-height: 30px;color: #909399;">1、批量卡号最多一次上传100张</p>
                <p style="font-size: 13px;line-height: 30px;color: #909399;">2、输入卡号点击下一步输入目标ICCID</p>
                <p style="font-size: 13px;line-height: 30px;color: #909399;">3、批量卡号可以指定套餐转移</p>
              </div>
            </el-form-item>
            
          </el-col>
        </el-row>
        <el-row v-if="batchForm.fieldType == '2'">
          <el-col :span="24">
            <el-form-item label="卡号列表" prop="iccids">
              <el-upload
                ref="upload"
                :limit="1"
                accept=".xlsx, .xls"
                :headers="upload.headers"
                :action="upload.url"
                :disabled="upload.isUploading"
                :on-progress="handleFileUploadProgress"
                :on-success="handleFileSuccess"
                :auto-upload="false"
                drag
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">
                  <span>仅允许导入xls、xlsx格式文件。</span>
                  <el-link type="primary" :underline="false" style="font-size:12px;vertical-align: baseline;" @click="importTemplate">下载模板</el-link>
                </div>
              </el-upload>
              <div style="padding-top:10px">
                <p style="font-size: 13px;line-height: 30px;color: #909399;">1、批量上传源ICCID和目标ICCID</p>
                <p style="font-size: 13px;line-height: 30px;color: #909399;">2、EXCEL上传会将源ICCID的所有使用中，未使用，已使用，已过期的套餐全部转移到目标ICCID</p>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFileForm" v-if="batchForm.fieldType=='2'">确 定</el-button>
        <el-button type="primary" @click="submitBatchForm" v-if="batchForm.fieldType=='1'">下一步</el-button>
        <el-button @click="cancelBatchForm">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { cardProductRecordList } from "@/api/api.js"; //转套餐列表
import { getToken } from '@/utils/auth'
export default {
  data() {
    return{
      queryParams:{
        iccid:undefined,
        orderNum:undefined,
        operator:undefined
      },
      tableData:[],
      page: 1,
      pageSize: 20,
      total:0,
      an:false,
      // 日期范围
      dateRange: [],
      // 申请退款
      ruleForm:{},
      batchFormOpen:false,
      batchForm:{
        fieldType:"1",
        iccids:undefined
      },
      upload: {
        isUploading: false,
        // 设置上传的请求头部
        headers: { Authorization: getToken()},
        // 上传的地址
        url: "/cms/cardProduct/import",
      },

    }
  },
  methods: {
    jumpCardDetails(iccid){
      this.$router.push({path:"/card/detail",query:{iccid: iccid}});
    },
    // 获取列表的数据
    initData(){
      let params = {
        model:{
          ... this.addDateRange(this.queryParams, this.dateRange),
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      params.model.type = "1";
      cardProductRecordList(params).then(res=>{
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      })
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.initData();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
    cancelBatchForm(){
      this.batchFormOpen = false
    },
    submitBatchForm(){
      let iccids = this.batchForm.iccids ? this.batchForm.iccids.split("\n") : [];
      if(iccids.length == 0){
        this.$message({type: 'error',message: "请输入批量卡号"});
        //清空数据
        this.$store.dispatch('ClearTransferIccids')
        return 
      }else{
        this.$store.dispatch('CacheTransferIccids', iccids.join(","))
        this.$router.push("/package/transferProduct");
        this.batchFormOpen = false
      }

    },
    batchUploadProduct(){
      this.batchFormOpen = true
    },
    importTemplate() {
      this.download('/cardProduct/importTemplate', {
      }, `cardProduct_template_${new Date().getTime()}.xlsx`)
    },
    // 文件上传中处理
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true;
    },
    // 文件上传成功处理
    handleFileSuccess(response, file, fileList) {
      this.batchFormOpen = false;
      this.upload.isUploading = false;
      this.$refs.upload.clearFiles();
      this.search();
    },
    // 提交上传文件
    submitFileForm() {
      this.$refs.upload.submit();
    },
  },
  mounted() {
    this.initData();
  },
  created() {
    
  }
};
</script>
<style scoped lang="less">

</style>


